import { toast } from "react-toastify";

export const NotificationSuccess = (message) => {
  return toast.success(message, {
    autoClose: 3000,
    theme: "colored",
    closeOnClick: true,
  });
};

export const NotificationError = (message) => {
  return toast.error(message, {
    autoClose: 3000,
    theme: "colored",
    closeOnClick: true,
  });
};

/**
 * Notification with action button
 * @param {string} message - The notification message
 * @param {string} title - The notification title
 * @param {number} autoClose - Auto close time in ms (default: 5000)
 * @param {function} onAction - Callback function when action button is clicked
 * @param {string} actionLabel - Label for action button (default: "Zobacz")
 */

export const PaymentNotification = (
  message,
  title = "Powiadomienie",
  autoClose = false,
  onAction = () => {},
  actionLabel = "Płatność",
) => {
  const NotificationContent = ({ closeToast }) => (
    <div className="d-flex flex-column gap-1 flex-grow-1">
      {title && (
        <strong style={{ fontSize: "14px", marginBottom: "4px" }}>
          {title}
        </strong>
      )}
      <div className="d-flex flex-row justify-content-between align-items-center">
        <span style={{ fontSize: "12px" }}>{message}</span>
        {onAction && (
          <button
            onClick={() => {
              onAction();
              closeToast();
            }}
            className="notificationButton"
            id="active"
          >
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
  return toast.info(NotificationContent, {
    autoClose,
    closeOnClick: !onAction, // Don't close on click if there's an action button
    theme: "colored",
  });
};

export const NotificationInfo = (
  message,
  title = "Powiadomienie",
  autoClose = 5000,
  onAction = null,
  actionLabel = "Zobacz",
) => {
  const NotificationContent = ({ closeToast }) => (
    <div className="d-flex flex-column gap-1 flex-grow-1">
      {title && (
        <strong style={{ fontSize: "14px", marginBottom: "4px" }}>
          {title}
        </strong>
      )}
      <div className="d-flex flex-row justify-content-between align-items-center">
        <span style={{ fontSize: "12px" }}>{message}</span>
        {onAction && (
          <button
            onClick={() => {
              onAction();
              closeToast();
            }}
            className="notificationButton"
            id="active"
          >
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );

  return toast.info(NotificationContent, {
    autoClose,
    closeOnClick: !onAction, // Don't close on click if there's an action button
    theme: "colored",
  });
};
